import * as angular from "angular";
import { Feature } from "../../models/feature.model";
import { ToastUtils } from "../../helper/toast.helper";

let ReceptionFeatureForm = {
    selector: "vcReceptionFeatureForm",
    bindings: {
        feature: "=?",
        autoSave: "=?",
        fieldsDisabled: "=?",
        isOrgCampaign: "=?",
    },
    templateUrl:
        "/angular/components/feature/reception-feature-form.component.html",
    controller: class ReceptionFeatureFormController {
        // * bindings for typescript compiler *
        public feature?: Feature;
        public autoSave?: boolean;
        public fieldsDisabled?: boolean;
        public isOrgCampaign?: boolean;
        // ************************************

        private readonly toast: ToastUtils;
        private readonly $scope: any;
        private $interval: any;

        public delay: any;

        constructor($scope: any, $interval: any, ToastUtils: ToastUtils) {
            this.$scope = $scope;
            this.$interval = $interval;
            this.toast = ToastUtils;
        }

        $onInit() {
            if (this.autoSave) {
                this.$scope.$watch(
                    () => this.feature,
                    (newValue: object, oldValue: object) => {
                        if (oldValue && newValue !== oldValue) {
                            if (this.delay) {
                                this.delay = this.$interval.cancel(this.delay);
                            }
                            this.delay = this.$interval(() => {
                                this.$interval.cancel(this.delay);

                                this.feature.update().then(
                                    () => {},
                                    () => this.toast.error()
                                );
                            }, 500);
                        }
                    },
                    true
                );
            }
        }
    },
};
angular
    .module("feature")
    .component(ReceptionFeatureForm.selector, ReceptionFeatureForm);
